import { Avatar, Col, Collapse, DatePicker, Divider, Input, Row, Select, Checkbox } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import GeneralBloc from "../../../bloc/general_bloc";
import ProfileBloc from "../../../bloc/profile_bloc";
import RouteBloc from "../../../bloc/route_bloc";
import App_header from "../../component/app_header/app_header";
import App_header_title_simple from "../../component/app_header_title/app_header_title_simple";
import Base_screen from "../base/base_screen/base_screen";
import UserAccessBloc from "../../../bloc/user_access_bloc";
import HomeBloc from "../../../bloc/home_bloc";
import Config from "../../../Config";

import "./mrtt_proposal_details.css";
import AppModal from "../../component/app_modal/app_modal";
import AppStandardDetailsCard from "../../component/app_quotation_card/app_standard_details_card";
import AppGeneratedDocumentsDetailsCard from "../../component/app_quotation_card/app_generated_documents_card2";
import AppCardStatus from "../../component/app_card_status/app_card_status";
import QuotationBloc from "../../../bloc/quotation_bloc";
import moment from "moment";
import AppBottomBar from "../../component/app_bottom_bar/app_bottom_bar";
import AppLoadingDialog from "../../dialog/app_loading_dialog";
import AppCollapse from "../../component/app_collapse/app_collapse";
import { ReactComponent as InfoIcon } from "../../../Info.svg";
import { ReactComponent as QRIcon } from "../../../QRCode.svg";
import { ReactComponent as EditIcon } from "../../../Edit.svg";
import { ReactComponent as EmailIcon } from "../../../Email.svg";
import { ReactComponent as MessageIcon } from "../../../Message.svg";
import { Button } from "reactstrap";
import QRCode from "react-qr-code";
import ProposalBloc from "../../../bloc/mrtt_proposal_bloc";
import AppUploadedDocumentsDetailsCard from "../../component/app_quotation_card/app_uploaded_documents_card";
import SignatureCanvas from 'react-signature-canvas'
import FormsBloc from "../../../bloc/forms_bloc";
import AppSelectField from "../../component/app_select_field/app_select_field";

class ProposalDetails extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.containerRef = React.createRef();
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            section: this.props.match.params.section,
            status: '',
            generateDoc: [],
            formData: null,
            isEmailSent: false,
            isClientReviewed: false,
            isClientSigned: false,
            OTPChannel: '1',
            QRCodeOpen: false,
            OTPOpen: false,
            qrContent: null,
            errorModalOpen: false,
            errorMessage: '',
            resendEmailInterval: Config.proposal.emailResendInterval,
            resendEmail: false,
            isSuccessModalOpen: false,
            isOpen: false,
            loading: false,
            waitSubmissionStatus: false,
            confirmSubmitOpen: false,
            signatureContent: null,
            intermediateDecOpen: false,
        };
    }

    getProposalId() {
        return this.props.match.params.itemId;
    }

    getUserDataHeader() {
        return this.state.userDataHeader;
    }
    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    generateProfileSettingValue() {
        let userSettings = this.getUserSettings().info[0].value;
        let userData = this.getUserData();
        let value = userData[userSettings];
        return value;
    }

    componentDidMount() {
    }

    componentDidUpdate() {
        if (this.state.resendEmail === true) {
            if (this.state.resendEmailInterval > 0) {
                this.resendEmailTimer = setTimeout(() =>
                    this.setState({ resendEmailInterval: this.state.resendEmailInterval - 1000 })
                    , 1000)
            } else {
                this.setState({ resendEmail: false })
            }

        }

        if (this.state.waitSubmissionStatus === true) {
            this.fetchProposalSubmissionStatus()
        }
    }

    componentWillUnmount() {
        clearTimeout(this.resendEmailTimer);
    }

    async fetchProposalSubmissionStatus() {
        let submitStatus = await ProposalBloc.proposalSubmissionStatus(this.getProposalId());
        console.log('continue checking status', submitStatus);
        if (submitStatus.success) {
            if (submitStatus.data.status == 1) {
                this.setState({
                    loading: false,
                    waitSubmissionStatus: false
                });
                this.handleSuccessModalOpen();
            } else if (submitStatus.data.status == 2) {
                this.setState({
                    loading: false,
                    isOpen: true,
                    title: 'Notification',
                    message: submitStatus.data.log,
                    waitSubmissionStatus: false
                })
            } else {
                setTimeout(() =>
                    this.setState({ waitSubmissionStatus: true })
                    , 3000)

            }
        }
    }

    companyNameByEntity = () => {
        if (this.props.userGlobal) {
            switch (this.props.userGlobal.roles[0].entity) {
                case Config.entity.hsbc.code:
                    return "HSBC Amanah";
                case Config.entity.alliance.code:
                    return "Alliance Islamic Bank Berhad";
                case Config.entity.mbsb.code:
                    return "MBSB Bank Berhad";
                default:
                    return null;
            }
        }

    }

    async initiateData() {
        this.setState({ loading: true });
        let userData = await UserAccessBloc.getUserData();
        let userSettings = await UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }

        let result = await ProposalBloc.getProposalDetail(this.getProposalId(), userData.username); //'SHA002'
        let generateDoc = await ProposalBloc.getProposalDocumentById(this.getProposalId());
        this.setState({
            formDetails: result,
            generateDoc: generateDoc.success ? generateDoc : [],
            reviewLink: result?.submitReview?.link || '',
            OTPChannel: result?.submitReview?.otpChannelType || '',
            loading: false
        });
    }

    stateFormDetails() {
        return this.state.formDetails;
    }

    getInitial(name) {
        let result = GeneralBloc.mergeIntoInitialName(name);
        return result;
    }

    getStatus() {
        return this.props.status;
    }

    stateModule() {
        return "proposal";
    }

    stateFormDetails() {
        return this.state.formDetails;
    }

    handleViewQuotation = (id) => {
        window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_details}/${id}`
    }

    async handleUpdateQuotation() {
        let editable = await QuotationBloc.editGeneratedQuotation(this.stateFormDetails()?.quotationId);
        if (editable.success) {
            window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_personal_details}/${this.stateFormDetails()?.quotationId}`
        } else {
            this.setState({
                isOpen: true,
                title: 'Notification',
                message: 'This proposal cannot be edit or update.'
            })
        }
    }

    async handleUpdateProposal() {
        let editable = await ProposalBloc.editGeneratedProposal(this.getProposalId());
        if (editable.success) {
            window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_provide_details}/${this.getProposalId()}`
        } else {
            this.setState({
                isOpen: true,
                title: 'Notification',
                message: 'This proposal cannot be edit or update.'
            })
        }
    }

    async handleSubmitProposal() {
        this.setState({ loading: true });
        let submit = await ProposalBloc.submitProposal({
            id: this.getProposalId(),
            signature: this.state.signatureContent,
            placeOfSigning: this.state.placeOfSigning
        });
        if (submit.success) {
            let submitStatus = await ProposalBloc.proposalSubmissionStatus(this.getProposalId());
            console.log('first check status', submitStatus);
            if (submitStatus.success) {
                if (submitStatus.data.status == 1) {
                    this.setState({ loading: false, isIntermediateScrollToEnd: false });
                    this.handleSuccessModalOpen();
                } else if (submitStatus.data.status == 2) {
                    this.setState({
                        loading: false,
                        isOpen: true,
                        title: 'Notification',
                        message: submitStatus.data.log
                    })
                } else {
                    this.setState({ waitSubmissionStatus: true });
                }
            }
        } else {
            this.setState({
                isOpen: true,
                title: 'Notification',
                message: 'Submission failed.'
            })
        }
        // window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_details}/${id}`
    }


    handleResendEmail = () => {
        // trigger resend email api
        this.setState({ resendEmail: true })
    }

    async handleUpdateOTP() {
        // email - 1, sms - 2
        let result = await ProposalBloc.changeOTPChannel(this.state.OTPChannel, this.getProposalId());
    }

    handleMessageModalClose = () => {
        this.setState({ isOpen: false });
    }

    handleMessageModalOpen = () => {
        this.setState({ isOpen: true });
    }

    handleOTPOpen = () => {
        this.setState({ OTPOpen: true })
    }
    handleOTPClose = () => {
        this.setState({ OTPOpen: false })
    }

    handleConfirmSubmitOpen = () => {
        this.setState({ confirmSubmitOpen: true })
    }
    handleConfirmSubmitClose = () => {
        this.setState({ confirmSubmitOpen: false })
    }

    handleQRCodeOpen = () => {
        if (this.state.qrContent) {
            this.setState({ QRCodeOpen: true });
        } else {
            // let loadingQRCode = this.handleSendForReview();
            // if (loadingQRCode) {
            this.setState({ QRCodeOpen: true });
            // }
        }
    }
    handleQRCodeClose = () => {
        this.setState({ QRCodeOpen: false })
    }

    handleSuccessModalOpen = () => {
        this.setState({ isSuccessModalOpen: true })
    }
    handleSuccessModalClose = () => {
        this.setState({ isSuccessModalOpen: false })
    }

    handleGoToDashboard = () => {
        window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal}`;
    }

    nricFormater = (val) => {
        let val2 = val.slice(0, 6) + '-' + val.slice(6);
        let nric = val2.slice(0, 9) + '-' + val2.slice(9);
        return nric;
    }

    millisToMinutesAndSeconds(millis) {
        var minutes = Math.floor(millis / 60000);
        var seconds = ((millis % 60000) / 1000).toFixed(0);
        return (
            seconds == 60 ?
                (minutes + 1) + ":00" :
                minutes + ":" + (seconds < 10 ? "0" : "") + seconds
        );
    }

    saveSignature = () => {
        let strImage = this.sigPad.getTrimmedCanvas().toDataURL('image/png')
        let signatureContent = strImage.split("base64,")[1];
        this.setState({ signatureContent: signatureContent })
    }

    async handleSendForReview(isResend = false) {
        this.setState({ loading: true, OTPOpen: false, resendEmail: true });
        let reviewResult = await ProposalBloc.submitForReview(this.getProposalId(), this.state.OTPChannel, isResend);
        if (reviewResult.success) {
            this.setState({ qrContent: 'data:application/jpg;base64,' + reviewResult.data.qrCode }, () => this.handleQRCodeOpen());
        } else {
            this.setState({
                isOpen: true,
                title: 'Error',
                description: reviewResult.message
            })
        }
        this.setState({ loading: false });
        return reviewResult.success ? true : false;
    }

    loadingContent() {
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <AppLoadingDialog isLoading={this.state.loading} />
            </div>
        );
    }

    renderTableHeader() {
        return (
            <div className="mt-3" style={{ width: '100%' }}>
                <div className="row d-flex m-0 table-header-container align-items-center ">
                    <div className="" style={{ width: '4%' }}>Yes</div>
                    <div className="" style={{ width: '4%' }}>No</div>
                    <div className="" style={{ width: '23%' }}>Medical Condition</div>
                    <div className="" style={{ width: '12%' }}>Date of Diagnosis</div>
                    <div className="" style={{ width: '20%' }}>Treatment Prescribed</div>
                    <div className="" style={{ width: '14%' }}>Attending Doctor{'\''}s Name</div>
                    <div className="" style={{ width: '18%' }}>Attending Doctor{'\''}s Address </div>
                </div>
            </div>
        )
    }

    renderTableBody(data) {
        return (
            <div className="row d-flex m-0 align-items-center table-body-container app-standard-content-field-content" style={{ width: '100%' }}>
                <div className="" style={{ width: '4%' }}>
                    <Checkbox
                        className={'disabledCheckedBox disabledTick'}
                        disabled
                        checked={data.checked == 'Yes'}
                    />
                </div>
                <div className="" style={{ width: '4%' }}>
                    <Checkbox
                        className="disabledCheckedBox disabledTick"
                        disabled
                        checked={data.checked == 'No'}
                    />
                </div>
                <div className="" style={{ width: '23%' }}>
                    {data?.condition}
                </div>
                <div className="" style={{ width: '12%' }}>
                    {data?.dateOfDiagnosis && moment(data?.dateOfDiagnosis).format('DD/MM/YYYY')}
                </div>
                <div className="pt-1" style={{ width: '20%' }}>
                    {data?.treatment}
                </div>
                <div className="pt-1" style={{ width: '14%' }}>
                    {data?.doctorName}
                </div>
                <div className="pt-1" style={{ width: '18%' }}>
                    {data?.doctorAddress}
                </div>
            </div>
        )
    }

    renderExtendedHealthData(data) {
        return (
            <>
                <Row className=''>
                    <Col className="col-lg-6 col-sm-12 mb-4">
                        <div className="app-content-field-tag">{data.q1.caption}</div>
                        <div className="app-standard-content-field-content">{data.q1.value}</div>
                    </Col>
                    <Col className="col-lg-6 col-sm-12 mb-4">
                        <div className="app-content-field-tag">{data.q2.caption}</div>
                        <div className="app-standard-content-field-content"> {data.q2.value}</div>
                    </Col>

                </Row>
                <Row className='mb-4'>
                    <Col className="col-lg-12 col-sm-12">
                        <div className="app-content-field-tag">{data.q3.caption}</div>
                        <div className="app-standard-content-field-content">{data.q3.value}</div>
                    </Col>
                </Row>
                <Row className="mb-4">
                    <Col className="col-lg-12 col-sm-12">
                        <div className="app-content-field-tag">{data.q4.caption}</div>
                        <div className="mt-2" style={{ overflowX: 'scroll', width: '100%' }}>
                            {this.renderTableHeader()}
                            {
                                data?.q4 && data.q4.value.map((item) => {
                                    return (
                                        this.renderTableBody(item)
                                    )
                                })
                            }
                        </div>
                    </Col>
                </Row>
                <Row className="mb-4">
                    <Col className="col-lg-12 col-sm-12">
                        <div className="app-content-field-tag">{data.q5.caption}</div>
                        <div className="mt-2">
                            {this.renderTableHeader()}
                            {
                                data?.q5 && data.q5.value.map((item) => {
                                    return (
                                        this.renderTableBody(item)
                                    )
                                })
                            }
                        </div>
                    </Col>
                </Row>
                <Row className="ml-0 mb-4">
                    <Col className="col-lg-12 col-sm-12">
                        <div className="app-content-field-tag">{data.q6.caption}</div>
                        <div className="mt-2">
                            {this.renderTableHeader()}
                            {
                                data?.q6 && data.q6.value.map((item) => {
                                    return (
                                        this.renderTableBody(item)
                                    )
                                })
                            }
                        </div>
                    </Col>
                </Row>
                <Row className="ml-0 mb-4">
                    <Col className="col-lg-12 col-sm-12">
                        <div className="app-content-field-tag">{data.q7.caption}</div>
                        <div className="mt-2">
                            {this.renderTableHeader()}
                            {
                                data?.q7 && data.q7.value.map((item) => {
                                    return (
                                        this.renderTableBody(item)
                                    )
                                })
                            }
                        </div>
                    </Col>
                </Row>
                <Row className="ml-0">
                    <Col className="col-lg-12 col-sm-12 mb-3">
                        <div className="app-content-field-tag">{data.q8.caption}</div>
                        <div className="mt-2">
                            {data.q8.value}
                        </div>
                    </Col>
                    {
                        data?.q8 && data.q8.value == 'Yes' &&
                        <Col className="col-lg-12 col-sm-12 ml-3 mb-4">
                            <div className="app-content-field-tag">{data.q8a.caption}</div>
                            <div className="mt-2">
                                {data.q8a.value + ' months'}
                            </div>
                        </Col>
                    }

                </Row>
            </>
        )
    }

    renderBottomBar() {
        if (this.stateFormDetails()?.status == 'PENDING_SUBMISSION' || this.stateFormDetails()?.status == 'PENDING_REVIEW') {
            return (
                <AppBottomBar
                    enable={true}
                    lableSaveAndClose={'View Quotation'}
                    lableNext={'Submit Proposal'}
                    alignContent={"right"}
                    buttonWidth={"auto"}
                    onSaveAndClose={(e) => { this.handleViewQuotation(this.stateFormDetails()?.quotationId) }}
                    onNext={(e) => this.handleSubmitProposal()}
                />
            )
        } else if (this.stateFormDetails()?.status == 'SUBMITTED') {
            return (
                <AppBottomBar
                    enable={true}
                    lableNext={'View Quotation'}
                    alignContent={"right"}
                    buttonWidth={"auto"}
                    onNext={(e) => { this.handleViewQuotation(this.stateFormDetails()?.quotationId) }}
                />
            )
        } else {
            <AppBottomBar
                enable={true}
                lableSaveAndClose={'Update Quotation'}
                lableNext={'Update Proposal'}
                alignContent={"right"}
                buttonWidth={"auto"}
                onNext={(e) => { this.handleUpdateProposal() }}
                onSaveAndClose={(e) => this.handleUpdateQuotation()}
            />
        }
    }

    messageModal() {
        return (
            <AppModal
                open={this.state.isOpen}
                handleModalClose={this.handleMessageModalClose}
                width={'40%'}
                title={this.state.title}
                subtitle={this.state.message}
                closable={false}
                positiveButtonText={'Close'}
                handlePositivePress={() => this.handleMessageModalClose()}
            />
        )
    }

    confirmSubmitModal() {
        return (
            <AppModal
                open={this.state.confirmSubmitOpen}
                handleModalClose={this.handleConfirmSubmitClose}
                width={'40%'}
                title={'Confirm Proposal Submission'}
                subtitle={'To proceed with submitting this proposal, you must provide your e-Signature and confirm the declaration below.'}
                closable={false}
                handlePositivePress={() => this.handleSubmitProposal()}
            >
                <div className="mt-3">
                    <div className="signature_instruction_header">Agent's e-Signature</div>
                    <div
                        className="mt-3 upload_signature_container w-100"
                        style={{ position: 'relative' }}
                        ref={(ref) => { this.signatureDiv = ref }} // Create a ref for the div
                    >
                        {
                            this.state.isSignatureStart ?
                                <SignatureCanvas penColor='black' ref={(ref) => { this.sigPad = ref }} onEnd={() => this.saveSignature()}
                                    canvasProps={{ width: this.signatureDiv?.offsetWidth || '100%', height: 125, className: 'sigCanvas' }} /> :
                                <div>
                                    <div className="d-flex align-items-center justify-content-center">
                                        <div className="upload_signature_icon_container" onClick={() => this.setState({ isSignatureStart: true })}>
                                            <img
                                                src={GeneralBloc.getAssetsContextPath() + "/assets/images/Signature.png"}
                                            />
                                        </div>
                                    </div>
                                    <div className="modal_subtitle mt-3">Upload e-signature</div>
                                </div>
                        }

                    </div>
                    <div className="mt-3">
                        <AppSelectField
                            title={'Place of Signing'}
                            value={this.state.placeOfSigning}
                            placeholder={'Select state...'}
                            options={FormsBloc.getStateSelections()}
                            fieldNames={{ label: ('stateName'), value: ('stateCode') }}
                            onChange={(e) => this.setState({ placeOfSigning: e })}
                        />
                    </div>
                    <div className="mt-3">
                        <Checkbox
                            checked={this.state.isConfirmIntermediary}
                            onChange={(e) => { }}
                        // onChange={(e) => this.setState({ isConfirmIntermediary: e.target.checked })}
                        >
                            I hereby declare and confirm on the
                            <span className="ml-1" style={{ color: '#EE7623', cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); this.setState({ intermediateDecOpen: true }) }}>
                                Intermediary Declaration
                            </span>
                        </Checkbox>
                    </div>
                </div>
                <div className="d-flex justify-content-end mt-4">
                    <Button
                        type="text"
                        onClick={() => this.handleConfirmSubmitClose()}
                        style={{
                            color: '#EE7623',
                            height: '40px',
                            width: '170px',
                            fontWeight: 600,
                            background: 'transparent',
                            border: 'none', borderRadius: 0,
                            boxShadow: 'none',
                        }}>
                        No, do not submit
                    </Button>
                    <Button
                        type="text"
                        disabled={!(this.state.isConfirmIntermediary && this.state.signatureContent && this.state.placeOfSigning)}
                        onClick={() => this.handleSubmitProposal()}
                        style={{
                            color: '#FFFFFF',
                            backgroundColor: (this.state.isConfirmIntermediary && this.state.signatureContent && this.state.placeOfSigning) ? '#183028' : '#A3ACA9',
                            height: '40px', width: '170px',
                            fontWeight: 600, borderRadius: 0,
                            boxShadow: 'none', border: 'none',
                        }}
                    >
                        Yes, submit
                    </Button>
                </div>
            </AppModal>
        )
    }

    handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop >= e.target.clientHeight;
        if (bottom) {
            this.setState({ isIntermediateScrollToEnd: true })
        }
    }

    intermediateDeclarationModal() {
        return (
            <AppModal
                open={this.state.intermediateDecOpen}
                handleModalClose={() => this.setState({ intermediateDecOpen: false })}
                width={'60%'}
                // title={'Intermediary Declaration'}
                closable={false}
            >
                <div className="p-2" style={{ height: '45vh', overflowY: 'scroll', scrollbarColor: '#EE7623' }} onScroll={(e) => this.handleScroll(e)} ref={this.containerRef} >
                    <div ref={this.contentRef} style={{ height: '50vh' }}>
                        <div className="quotation_privacy_policy_container d-flex">
                            <span className="quotation_privacy_policy_title">{('Intermediary Declaration').toLocaleUpperCase()}</span>
                        </div>
                        I hereby declare and confirm that:
                        <ol type={'a'}>
                            <li className="mt-3">
                                All the information contained in this application form is the only information given to me by the applicant and/or person to be covered and I have not withheld any other information which might influence the acceptance of this application by FWD Takaful;
                            </li>
                            <li className="mt-3">
                                I have not made any statement, representation or promise to the applicant and/or person to be covered which is contrary to and/or misrepresents the terms of the Takaful Certificate, and/or to any relevant and applicable laws and standards that govern Takaful intermediaries' activity. I have not acted or conducted myself in such a way that amounts to misrepresenting the terms of the Takaful Certificate;
                            </li>
                            <li className="mt-3">
                                I have disclosed the essential information in connection with the Takaful plan as required under Malaysian laws and regulations, to the
                            </li>
                            <li className="mt-3">
                                Pursuant to the Anti-Money Laundering, Anti-Terrorism Financing and Proceeds of Unlawful Activities Act 2001, I confirm that where the person is an individual, I have sighted the original MyKad/valid passport and verified the identity of the proposed person covered/applicant; or if other than an individual person, I have sighted the original constituent and identification documents; and have verified the beneficial owners and details of the
                            </li>
                        </ol>
                    </div>
                </div>
                <div className="column mt-3 d-flex justify-content-end">
                    <Button
                        type='text'
                        style={{
                            color: '#FFFFFF',
                            backgroundColor: this.state.isIntermediateScrollToEnd ? '#183028' : '#A3ACA9',
                            fontSize: 14,
                            fontWeight: '600',
                            width: 170,
                            height: 40,
                            borderRadius: 0
                        }}
                        className="d-flex align-items-center justify-content-center"
                        onClick={() => this.setState({ isConfirmIntermediary: true, intermediateDecOpen: false })}
                        disabled={Boolean(!this.state.isIntermediateScrollToEnd)}
                    >
                        OK
                    </Button>
                </div>
            </AppModal>
        )
    }

    successMessageModal() {
        return (
            <AppModal
                open={this.state.isSuccessModalOpen}
                handleModalClose={this.handleMessageModalClose}
                width={'60%'}
                title={'Proposal Submission Successful!'}
                subtitle={'You have successfully submitted the proposal.'}
                closable={false}
                positiveButtonText={'Go back to dashboard'}
                handlePositivePress={() => this.handleGoToDashboard()}
            />
        )
    }

    qrModal() {
        return (
            <AppModal
                open={this.state.QRCodeOpen}
                handleModalClose={this.handleQRCodeClose}
                width={'40%'}
                title={'Scan QR Code'}
                subtitle={'Scan QR Code to review proposal'}
                closable={false}
            >
                <div className="w-100 d-flex justify-content-center mt-3">
                    {
                        this.state.qrContent ?
                            <img className="img-fluid" style={{ objectFit: "cover" }}
                                src={this.state.qrContent}
                            />
                            :
                            <QRCode value={this.state.reviewLink} />
                    }
                </div>
            </AppModal>
        )
    }

    otpModal() {
        return (
            <AppModal
                open={this.state.OTPOpen}
                handleModalClose={() => this.handleOTPClose()}
                width={'50%'}
                title={'How do you want to send the OTP?'}
                negativeButtonText={'Cancel'}
                positiveButtonText={'Update'}
                handleNegativePress={() => this.handleOTPClose()}
                handlePositivePress={() => this.handleUpdateOTP()}
                closable={false}
            >
                <div className="mt-2 otp_content_text">
                    <span style={{ color: '#171725' }}>Select OTP Channel <span style={{ color: 'red' }}>*</span></span>
                    <div className="mt-3 d-flex row mx-1">
                        <Button
                            className="d-flex align-items-center justify-content-center"
                            style={{
                                width: '50%',
                                height: '48px',
                                borderRadius: 0,
                                boxShadow: 'none',
                                borderColor: this.state.OTPChannel == '1' ? '#EE7623' : '#D9D9D9',
                                color: this.state.OTPChannel == '1' ? 'white' : 'black',
                                backgroundColor: this.state.OTPChannel == '1' ? '#EE7623' : '#FFFFFF'
                            }}
                            onClick={() => this.setState({ OTPChannel: '1' })}
                        >
                            <EmailIcon className="mr-2" fill={this.state.OTPChannel == '1' ? 'white' : '#92929D'} />
                            Email
                        </Button>
                        <Button
                            className="d-flex align-items-center justify-content-center"
                            style={{
                                width: '50%',
                                height: '48px',
                                borderRadius: 0,
                                boxShadow: 'none',
                                borderColor: this.state.OTPChannel == '2' ? '#EE7623' : '#D9D9D9',
                                color: this.state.OTPChannel == '2' ? '#FFFFFF' : '#000000',
                                backgroundColor: this.state.OTPChannel == '2' ? '#EE7623' : '#FFFFFF'
                            }}
                            onClick={() => this.setState({ OTPChannel: '2' })}
                        >
                            <MessageIcon className="mr-2" fill={this.state.OTPChannel == '2' ? 'white' : '#92929D'} />SMS
                        </Button>
                    </div>
                </div>

            </AppModal>
        )
    }

    render() {
        return (
            <>
                <Base_screen
                    listener={() => {
                        this.getEntity();
                        this.initiateData();
                    }}
                >
                    <>
                        <App_header
                            data={this.getUserDataHeader()}
                            route={this.getEntity()}
                        />
                        <div
                            style={{
                                marginTop: 110,
                                paddingLeft: 42,
                                paddingRight: 42,
                                paddingBottom: 100,
                                fontFamily: 'Lato'
                            }}
                        >
                            {this.state.loading && this.loadingContent()}
                            <div className="row m-0 w-100">
                                <App_header_title_simple
                                    title={'Ref No. ' + (this.stateFormDetails()?.refNo || 'N/A')}
                                    handleBack={() => this.handleGoToDashboard()}
                                />
                            </div>
                            <div className="px-5">
                                <AppCardStatus
                                    status={this.stateFormDetails()?.status}
                                    module={'proposal'}
                                />
                            </div>

                            <div className="w-100 px-3 pb-4">
                                {
                                    this.stateFormDetails()?.status !== 'SUBMITTED' &&
                                    <div className="d-flex mt-4 mx-3 p-3 notice_container">
                                        <InfoIcon />
                                        <div className="ml-3">
                                            <div className="notice_header">{Config.proposal.clientReviewMapping.pendingReview.noticeHeader}</div>
                                            <div className="notice_instruction mt-2">
                                                {Config.proposal.clientReviewMapping.pendingReview.noticeContent}
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="ml-0 mr-0 mt-3 row">
                                    <div className="col-8">
                                        {this.stateFormDetails()?.personalDetails && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.personalDetails) && (
                                            <AppStandardDetailsCard
                                                data={this.stateFormDetails().personalDetails}
                                                fields={
                                                    Config.proposal.dataDetailMapping.personalDetails || []
                                                }
                                                header={Config.proposal.formDataMapping.step1.personalDetailsTitle}
                                            />
                                        )}
                                        {this.stateFormDetails()?.mortgageDetails && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.mortgageDetails) && (
                                            <AppStandardDetailsCard
                                                data={this.stateFormDetails().mortgageDetails}
                                                fields={
                                                    Config.proposal.dataDetailMapping.mortgageDetails || []
                                                }
                                                header={Config.proposal.formDataMapping.step1.mortgageDetailsTitle}
                                            />
                                        )}
                                        {this.stateFormDetails()?.creditCardPayment && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.creditCardPayment) && (
                                            <AppStandardDetailsCard
                                                data={this.stateFormDetails().creditCardPayment}
                                                fields={
                                                    Config.proposal.dataDetailMapping.creditCardPayment ||
                                                    []
                                                }
                                                header={Config.proposal.formDataMapping.step1.creditCardDetailsTitle}
                                            />
                                        )}
                                        {this.stateFormDetails()?.healthStatement && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.healthStatement) && (
                                            <AppStandardDetailsCard
                                                data={this.stateFormDetails().healthStatement}
                                                fields={
                                                    Config.proposal.dataDetailMapping.healthStatement || []
                                                }
                                                header={Config.proposal.formDataMapping.step1.healthStatementTitle}
                                            />
                                        )}
                                        {this.stateFormDetails()?.directCredit && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.directCredit) && (
                                            <AppStandardDetailsCard
                                                data={this.stateFormDetails().directCredit}
                                                fields={
                                                    Config.proposal.dataDetailMapping.directCreditDetails || []
                                                }
                                                header={Config.proposal.formDataMapping.step1.directCreditDetailsTitle}
                                            />
                                        )}
                                        {this.stateFormDetails()?.payorInformation && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.payorInformation) && (
                                            <AppStandardDetailsCard
                                                data={this.stateFormDetails().payorInformation}
                                                fields={
                                                    Config.proposal.dataDetailMapping.payorInformation || []
                                                }
                                                header={Config.proposal.formDataMapping.step1.payorInformationTitle}
                                            />
                                        )}
                                        {this.stateFormDetails()?.extendedHealthDetails && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.extendedHealthDetails) && (
                                            <>
                                                <AppCollapse
                                                    header={Config.proposal.formDataMapping.step1.extendedHealthDeclarationTitle}
                                                >
                                                    {this.renderExtendedHealthData(this.stateFormDetails()?.extendedHealthDetails)}
                                                </AppCollapse>
                                            </>

                                        )}
                                        {this.stateFormDetails()?.foreignerDetails && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.foreignerDetails) && (
                                            <AppStandardDetailsCard
                                                data={this.stateFormDetails().foreignerDetails}
                                                fields={
                                                    Config.proposal.dataDetailMapping.foreigner || []
                                                }
                                                header={Config.proposal.formDataMapping.step1.foreignQuestionaireTitle}
                                            />
                                        )}
                                        {this.stateFormDetails()?.generalOccDetails && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.generalOccDetails) && (
                                            <AppStandardDetailsCard
                                                data={this.stateFormDetails().generalOccDetails}
                                                fields={
                                                    Config.proposal.dataDetailMapping.generalOcc || []
                                                }
                                                header={Config.proposal.formDataMapping.step1.generalOccupationTitle}
                                            />
                                        )}
                                        {this.stateFormDetails()?.oilGasDetails && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.oilGasDetails) && (
                                            <AppStandardDetailsCard
                                                data={this.stateFormDetails().oilGasDetails}
                                                fields={
                                                    Config.proposal.dataDetailMapping.oilAndGasOcc || []
                                                }
                                                header={Config.proposal.formDataMapping.step1.oilGasTitle}
                                            />
                                        )}
                                        {this.stateFormDetails()?.resTravelDetails && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.resTravelDetails) && (
                                            <AppStandardDetailsCard
                                                data={this.stateFormDetails().resTravelDetails}
                                                fields={
                                                    Config.proposal.dataDetailMapping.residentialForeignTravel || []
                                                }
                                                header={Config.proposal.formDataMapping.step1.residentailForeignTravelTitle}
                                            />
                                        )}
                                        {this.stateFormDetails()?.generatedDocuments && (
                                            <AppGeneratedDocumentsDetailsCard
                                                title={'Uploaded Documents'}
                                                module={'proposal'}
                                                data={this.stateFormDetails().generatedDocuments}
                                            />
                                        )}
                                        {
                                            this.state.generateDoc && this.state.generateDoc?.data?.length > 0 &&
                                            <AppUploadedDocumentsDetailsCard
                                                module={'proposal'}
                                                data={this.state.generateDoc}
                                            />
                                        }


                                    </div>
                                    <div className="col-4 p-3">
                                        <div
                                            className="client_detail_header_container"
                                            style={{
                                                backgroundColor:
                                                    (this.stateFormDetails()?.status == 'PENDING_SUBMISSION' || this.stateFormDetails()?.status == 'SUBMITTED') ?
                                                        '#E7F3F0' : '#F9E5D8'
                                            }}
                                        >
                                            <InfoIcon />
                                            <div className="ml-3">
                                                <div className="notice_header">Client{'\''}s Details</div>
                                                <div className="notice_instruction mt-2">
                                                    To review proposal
                                                </div>
                                            </div>
                                        </div>
                                        <div className="client_detail_content_container">
                                            <div className="w-100 d-flex justify-content-between">
                                                <div className="client_detail_content_text">
                                                    Name
                                                </div>
                                                <div className="client_detail_content_text2">
                                                    {this.stateFormDetails()?.personalDetails.name.value || '-'}
                                                </div>
                                            </div>
                                            <div className="w-100 d-flex justify-content-between mt-2">
                                                <div className="client_detail_content_text">
                                                    NRIC
                                                </div>
                                                <div className="client_detail_content_text2">
                                                    {this.stateFormDetails()?.personalDetails.idNo.value && this.nricFormater(this.stateFormDetails()?.personalDetails.idNo.value) || '-'}
                                                </div>
                                            </div>
                                            <div className="w-100 d-flex justify-content-between mt-2">
                                                <div className="client_detail_content_text">
                                                    Mobile No.
                                                </div>
                                                <div className="client_detail_content_text2">
                                                    {this.stateFormDetails()?.personalDetails?.mobileNumber?.value || '-'}
                                                </div>
                                            </div>
                                            <div className="w-100 d-flex justify-content-between mt-2">
                                                <div className="client_detail_content_text">
                                                    Email
                                                </div>
                                                <div className="client_detail_content_text2 ml-2" style={{ wordBreak: 'break-all' }}>
                                                    {this.stateFormDetails()?.personalDetails.email.value || '-'}
                                                </div>
                                            </div>

                                            <div className="w-100 d-flex justify-content-between align-items-center mt-2">
                                                {
                                                    this.stateFormDetails()?.status == 'PENDING_SUBMISSION' || this.stateFormDetails()?.status == 'SUBMITTED' ?
                                                        <span style={{ color: '#EE7623' }}>This proposal has been reviewed and signed.</span> :
                                                        <>
                                                            <div className="client_detail_content_text">
                                                                {
                                                                    this.state.resendEmail ?
                                                                        <>
                                                                            <div className="client_detail_content_text">Email has been sent</div>
                                                                            <div className="client_detail_content_text2">Retry in {this.millisToMinutesAndSeconds(this.state.resendEmailInterval)}</div>
                                                                        </>
                                                                        :
                                                                        <span style={{ color: '#EE7623' }}>Pending Review</span>
                                                                }

                                                            </div>
                                                            <div className="">
                                                                <Button
                                                                    style={{
                                                                        color: 'white',
                                                                        backgroundColor: '#EE7623',
                                                                        borderRadius: 0,
                                                                        boxShadow: 'none',
                                                                        border: '0px',
                                                                        fontWeight: 600,
                                                                        fontSize: 14,
                                                                        height: 44,
                                                                        width: 132
                                                                    }}
                                                                    onClick={() => this.handleSendForReview()}
                                                                    disabled={this.state.resendEmail}
                                                                >
                                                                    Resend {this.state.OTPChannel == '1' ? ' Email' : ' SMS'}
                                                                </Button>
                                                            </div>
                                                        </>

                                                }

                                            </div>
                                            {
                                                (this.stateFormDetails()?.status == 'PENDING_REVIEW' || this.stateFormDetails()?.status == 'DRAFT') &&
                                                <>
                                                    <Divider />
                                                    <div className="d-flex row ">
                                                        <div
                                                            className="col-6 p-1 client_detail_review_method "
                                                            onClick={() => this.handleQRCodeOpen()}
                                                        >
                                                            Show QR Code <QRIcon className="ml-2" />
                                                        </div>
                                                        <div
                                                            className="col-6 p-1 client_detail_review_method"
                                                            onClick={() => this.handleOTPOpen()}
                                                        >
                                                            Change OTP Channel<EditIcon className="ml-2" fill={'#92929D'} />
                                                        </div>
                                                    </div>
                                                </>
                                            }

                                        </div>
                                    </div>
                                    {
                                        this.stateFormDetails()?.status == 'PENDING_SUBMISSION' &&
                                        <div style={{ marginTop: '8vh' }}>
                                            By clicking “Submit Proposal”, I hereby certify that the above signature was made in my presence and that to my own personal knowledge it is the signature of Person to be Covered under the proposal mentioned above.
                                        </div>
                                    }
                                </div>
                            </div>

                        </div >
                        {this.renderBottomBar()}

                        {this.qrModal()}

                        {this.otpModal()}

                        {this.messageModal()}

                        {this.successMessageModal()}

                        {this.confirmSubmitModal()}

                        {this.intermediateDeclarationModal()}

                    </>
                </Base_screen>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(ProposalDetails));
